import { createEvent } from 'effector'

export const initializeApp = createEvent()
export const setDrawerVisible = createEvent<boolean>()
